import { useEffect, useRef } from 'react'
import { useRafCallback } from '@/hooks/use-raf-callback'
import { useReducedMotion } from '@/hooks/use-reduced-motion'
import { useMediaQuery } from '@/hooks/use-media-query'

export function CursorGlow() {
  const ref = useRef<HTMLDivElement>(null)
  const reduced = useReducedMotion()
  const finePointer = useMediaQuery('(pointer: fine)')

  const move = useRafCallback((x: number, y: number) => {
    const element = ref.current
    if (element === null) return
    element.style.setProperty('--cursor-x', `${x.toFixed(1)}px`)
    element.style.setProperty('--cursor-y', `${y.toFixed(1)}px`)
    element.dataset.active = 'true'
  })

  useEffect(() => {
    if (reduced || !finePointer) return

    const onMove = (event: PointerEvent) => {
      if (event.pointerType !== 'mouse') return
      move(event.clientX, event.clientY)
    }
    const onLeave = () => {
      const element = ref.current
      if (element !== null) element.dataset.active = 'false'
    }

    window.addEventListener('pointermove', onMove, { passive: true })
    document.addEventListener('pointerleave', onLeave)
    return () => {
      window.removeEventListener('pointermove', onMove)
      document.removeEventListener('pointerleave', onLeave)
    }
  }, [move, reduced, finePointer])

  if (reduced || !finePointer) return null

  return <div className="cursor-glow" ref={ref} data-active="false" aria-hidden="true" />
}
